import React from "react";
import { Flame, MapPin } from "lucide-react";

export default function HookAd() {
  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-6">
      <div className="flex flex-col items-center gap-6">
        <p className="font-['Outfit'] text-zinc-300 text-sm uppercase tracking-[0.3em]">
          Hook Ad · 1080×1080
        </p>

        <div
          data-testid="hook-ad"
          className="relative w-[540px] h-[540px] overflow-hidden bg-black"
        >
          {/* Hero food shot: pulled pork sandwich */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                "url(https://static.prod-images.emergentagent.com/jobs/6ad5284b-01f5-432e-9dd7-8388ae8bdde3/images/ea2515a2333c003b27a647814b302029d3cce5e873cb14aabd10c36f28866c54.png)",
              backgroundSize: "cover",
              backgroundPosition: "center 55%",
              filter: "saturate(1.15) contrast(1.05) brightness(0.85)",
            }}
          />
          {/* Heavy dark overlay so type wins */}
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 38%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.95) 100%)",
            }}
          />
          {/* Side ember vignette */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse at 50% 100%, rgba(255,59,48,0.35), transparent 65%)",
            }}
          />
          {/* Grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-30 mix-blend-screen pointer-events-none"
            style={{
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/><feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
            }}
          />

          {/* Brand top-left */}
          <div className="absolute top-5 left-5 flex items-center gap-2 z-10">
            <Flame
              className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
              style={{ width: 18, height: 18 }}
            />
            <span
              className="font-['Anton'] uppercase text-white tracking-[0.3em]"
              style={{ fontSize: 13 }}
            >
              Smokey <span className="text-[#FF3B30]">AF</span>
            </span>
          </div>

          {/* Now Open diagonal stamp top-right */}
          <div
            className="absolute top-12 -right-5 z-10 bg-[#FF3B30] text-white font-['Anton'] uppercase tracking-widest px-8 py-1.5 shadow-[0_8px_24px_rgba(255,59,48,0.6)]"
            style={{ fontSize: 18, transform: "rotate(12deg)" }}
          >
            Now Open
          </div>

          {/* Top — Fremont eyebrow */}
          <div className="absolute top-[55px] left-6 right-6 z-10">
            <div className="flex items-center gap-2">
              <MapPin className="w-3.5 h-3.5 text-[#FF8C00]" />
              <span
                className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.45em]"
                style={{ fontSize: 11 }}
              >
                Fremont, Nebraska
              </span>
            </div>
          </div>

          {/* Main hook — diagonal energy */}
          <div className="absolute top-[100px] left-6 right-6 z-10">
            <h1
              className="font-['Anton'] uppercase text-white leading-[0.82] drop-shadow-[0_8px_25px_rgba(0,0,0,0.95)]"
              style={{ fontSize: 70, letterSpacing: "-0.02em" }}
            >
              Stop driving
              <br />
              to{" "}
              <span
                className="line-through decoration-[#FF3B30]"
                style={{
                  textDecorationThickness: 5,
                  textShadow: "0 4px 18px rgba(0,0,0,0.9)",
                }}
              >
                Omaha
              </span>
              <br />
              for{" "}
              <span style={{ color: "#FF3B30" }}>real BBQ</span>.
            </h1>
          </div>

          {/* Bottom CTA strip */}
          <div className="absolute inset-x-0 bottom-0 px-6 pb-6 z-10">
            <p
              className="font-['Outfit'] text-zinc-200 italic mb-3"
              style={{ fontSize: 14 }}
            >
              Hand-pulled. Wood-fired. Honest as hell. Plates from{" "}
              <span className="text-white font-semibold">$7</span>.
            </p>
            <div className="flex items-end justify-between gap-3">
              <div>
                <div
                  className="font-['Outfit'] uppercase text-zinc-400 tracking-[0.3em]"
                  style={{ fontSize: 9 }}
                >
                  Inside Southern Style Bar
                </div>
                <div
                  className="font-['Anton'] uppercase text-white tracking-wider mt-0.5"
                  style={{ fontSize: 14 }}
                >
                  648 N Broad St · Fremont
                </div>
              </div>
              <span
                className="font-['Anton'] tracking-widest uppercase bg-[#FF3B30] text-white px-4 py-2 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
                style={{ fontSize: 13 }}
              >
                Order Now
              </span>
            </div>
            <div
              className="mt-2 text-center font-['Outfit'] uppercase text-zinc-500 tracking-[0.3em]"
              style={{ fontSize: 9 }}
            >
              smokey-af-bbq.emergent.host
            </div>
          </div>
        </div>

        <a
          href="/fremont-hook-ad.png"
          download
          data-testid="hook-ad-dl"
          className="font-['Anton'] text-sm tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-6 py-3 transition-colors"
        >
          Download PNG
        </a>
      </div>
    </div>
  );
}
